//return is true if the interval is valid.
//Expects date string aaaa-mm-dd

const checkValidIntervalDate = (dt_inicio: string, dt_fim: string): boolean => {
  return new Date(dt_inicio) <= new Date(dt_fim);
};

export default checkValidIntervalDate;
